export const spacings = {
  main: {
    x: 68,
    y: 72,
  },

}
